const SUPERVISOR_ROLE_NAME = "Supervisor"

interface RolPrincipalResult {
    puestoOrol: string
    puestoNombre: string
    areaId: string
    esSupervisor: boolean
}

interface HotelColaboradorLike {
    puesto_id: string
    area_id: string
    puesto?: { nombre?: string | null } | null
}

/**
 * Un colaborador puede tener más de un rol en colaborador_in_hotel (ej. su rol
 * principal + "Supervisor"). El rol principal es el que no es "Supervisor"; si
 * solo tiene un rol, ese es el principal aunque sea "Supervisor".
 */
const getRolPrincipal = (
    colaboradorInHotel?: HotelColaboradorLike[] | null
): RolPrincipalResult => {
    const roles = colaboradorInHotel || []
    const rolSupervisor = roles.find((r) => r?.puesto?.nombre === SUPERVISOR_ROLE_NAME)
    const otroRol = roles.find((r) => r?.puesto?.nombre !== SUPERVISOR_ROLE_NAME)
    const rolPrincipal = roles.length > 1 && rolSupervisor && otroRol ? otroRol : roles?.[0]

    return {
        puestoOrol: rolPrincipal?.puesto_id || "",
        puestoNombre: rolPrincipal?.puesto?.nombre || "",
        areaId: rolPrincipal?.area_id || "",
        esSupervisor: Boolean(rolSupervisor) && roles.length > 1,
    }
}

export default getRolPrincipal
